import React from 'react';

// tabs: [{ id, label, icon? }]
// active: id de l'onglet actif
// onChange: (id) => void
export default function TabBar({ tabs, active, onChange, className = '' }) {
    return (
        <div className={`flex gap-1 bg-white/70 dark:bg-white/[0.03] backdrop-blur-xl border border-gray-200 dark:border-white/[0.05] rounded-2xl p-1 w-fit ${className}`}>
            {tabs.map(tab => (
                <button
                    key={tab.id}
                    onClick={() => onChange(tab.id)}
                    className={`flex items-center gap-2 px-4 py-2 rounded-xl text-sm font-semibold transition-all whitespace-nowrap
                        ${active === tab.id
                            ? 'bg-cyan-500/15 text-cyan-700 dark:text-cyan-300 border border-cyan-500/30 shadow-sm'
                            : 'text-gray-500 dark:text-gray-400 hover:text-gray-700 dark:hover:text-gray-200 hover:bg-gray-100 dark:hover:bg-white/[0.05]'
                        }`}
                >
                    {tab.icon && <span className="shrink-0">{tab.icon}</span>}
                    {tab.label}
                </button>
            ))}
        </div>
    );
}
